import useSWR from 'swr';
import { AI_TRANSLATE_LANGUAGES_URL } from '@/constant/approval';
import { getNestedDataFetcher } from '@/utils/apis';

/**
 * AI 번역 가능 언어 항목. `code`(예: 'zh-CN')는 localStorage 영속 key 로도 사용.
 * 응답 envelope: `{ data: AITranslateLanguage[] }`.
 */
export type AITranslateLanguage = {
  code: string;
  nativeName: string;
  englishName: string;
};

/**
 * AI 번역 언어 목록 조회.
 * - enabled=false 면 호출 skip — 번역 팝업 열기 전 페이지 진입마다 fetch 방지.
 * - revalidateOnFocus: false — 목록이 거의 정적이라 재조회 불필요.
 */
const useAITranslateLanguages = (enabled: boolean) => {
  const { data, error, isLoading } = useSWR<AITranslateLanguage[]>(
    enabled ? AI_TRANSLATE_LANGUAGES_URL : null,
    (url: string) => getNestedDataFetcher<AITranslateLanguage[]>(url),
    {
      revalidateOnFocus: false,
    },
  );

  return {
    languages: data ?? [],
    error,
    isLoading,
  };
};

export default useAITranslateLanguages;
